import { render, staticRenderFns } from "./Llamada.vue?vue&type=template&id=d9cab758"
import script from "./Llamada.vue?vue&type=script&lang=js"
export * from "./Llamada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports